module.exports = __webpack_public_path__ + "static/media/result_rchic_ja_old.af553af2.jpg";